import type { VideoContentObject } from 'models';
import { Form, FormActions, generateUploadFile, getDatePickerDateType } from 'ui';
import {
  VideoBasicInfoFormContent,
  type VideoBasicInfoFormValues,
  VideoChannelsFormContent,
  type VideoChannelsFormValues,
} from '../../../../components';

export type VideoEditFormValues = VideoBasicInfoFormValues & VideoChannelsFormValues;

type P = {
  isLoading: boolean;
  onSuccess: (values: VideoEditFormValues) => void;
  videoContentObject: VideoContentObject;
};

const VideoEditForm = ({ isLoading, onSuccess, videoContentObject }: P) => {
  const { organization, video } = videoContentObject;

  const onFinish = (values: VideoEditFormValues) => {
    onSuccess(values);
  };

  const initialValues: Partial<VideoEditFormValues> = {
    coverPhoto: video.coverPhoto ? generateUploadFile({ response: video.coverPhoto }) : undefined,
    featuredInChannels: video.featuredInChannels,
    htmlDescription: video.htmlContent,
    name: video.name,
    organization: {
      customChannels: organization.customChannels,
      label: organization.name,
      tags: organization.tags,
      value: organization.id,
    },
    recordedAt: getDatePickerDateType(video.recordedAt),
    showInChannels: video.showInChannels,
    tags: video.tags.map((tag) => ({
      label: tag.name,
      value: tag.id,
    })),
    textDescription: video.textContent,
  };

  return (
    <Form<VideoEditFormValues> initialValues={initialValues} onFinish={onFinish}>
      <VideoBasicInfoFormContent mode="edit" />
      <VideoChannelsFormContent<VideoEditFormValues> />
      <FormActions submit={{ children: 'Save', loading: isLoading }} />
    </Form>
  );
};

export default VideoEditForm;
